<template>
    <div class="side-block header-side">
        <div class="block-title" :class="{'title-border':titleBorder}">
            作者推荐
        </div>
        <div class="line"></div>
        <div class="list">
            <div class="item" v-for="item in experts" :key="item.userId">
                <div class="userheader">
                    <router-link :to="{path:'/user/',query:{id:item.userId}}" target="_blank">
                        <img v-if="item.imgUrl" :src="imgSiteUrl+item.imgUrl" alt="">
                        <img src="~@/assets/img/head1.png" style="background:#f0f3f6;" alt="">
                    </router-link>
                </div>
                <div class="btn f-r" v-if="item.status===1">
                    <span class="btn1">已关注</span>
                    <span class="btn2" @click="setFocus(item)">取消关注</span>
                </div>
                <a-button class="f-r" @click="setFocus(item)" type="primary" size="small" v-else style="width:68px">关注</a-button>
                <div class="username">
                    <router-link :to="{path:'/user/',query:{id:item.userId}}" target="_blank">{{item.userName.length>6?item.userName.slice(0,6)+"...":item.userName}}</router-link>
                </div>
                <div class="author-position" :title="item.presonalProfile" v-if="item.presonalProfile">{{item.presonalProfile}}</div>
                <div class="author-position" :title="item.presonalProfile" v-else>这个用户很神秘，暂时没有留下介绍哦～</div>
                <div class="clear"></div>
                <div class="bottom-line"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, onMounted, ref,computed} from 'vue';
import Http from '../until/http';
import config from '../until/configs';
import { confirmLogin, getCookie, messageTips } from '../until/tools';
export default defineComponent({
    props:['titleBorder'],
    setup() {
        let experts = ref([])
        const imgSiteUrl = computed(()=>{
            return config.imgSiteUrl;
        });
        const sid = computed(()=>{
            return getCookie('z_sid');
        })
        onMounted(()=>{
            Http.getExpertRec({pageNow:1}).then(res=>{
                if(res.authorRecommend) {
                    experts.value = res.authorRecommend;
                }
            });
        });

        const setFocus = (item)=>{
            if(!sid.value) {
                confirmLogin();
                return false;
            }
            let params = {
                resId:item.userId,
                flag:item.status?1:0
            }
            Http.foucsAuthor(params).then(res=>{
                if(res) {
                    if(res.success) {
                        item.status = params.flag?0:1;
                    } else {
                        messageTips(res.message,1);
                    }
                }
            });
        }

        return {
            experts,
            imgSiteUrl,
            setFocus
        }
    }
})
</script>

<style lang="scss" scoped>
@import '../scss/_variables.scss';
.side-block {
    margin-bottom: 12px;
    // padding:5px 0;
    background:#fff;
    margin-bottom: 12px;
    .block-title {
        line-height: 50px;
        font-size:16px;
    }
    .line{
        height: 0.5px;
        background:#E8E8E8;
            width: 308px;
    margin-left: -15px;
    }
    .title-border {
        line-height: 50px;
    }
    .list {
        padding:20px 2px 0;
        .item {
            margin-bottom: 12px;
            .userheader {
                height: 46px;
                width: 46px;
                float: left;
                border-radius: 50%;
                overflow: hidden;
                background: #eee;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            a {
                color:#333;
            }
            a:hover {
                color:$primary-color;
            }
            .f-r {
                float:right;
            }
            .focus {
                color: #e75934;
                cursor: pointer;
            }
            .focused {
                color: #969696;
                cursor: pointer;
            }
            .btn {
                width:68px;
                height:24px;
                line-height:22px;
                text-align: center;
                border:1px solid #e75934;
                border-radius: 2px;
                color:#e75934;
                font-size:14px;
                cursor: pointer;
                .btn1 {
                    display: inline;
                }
                .btn2 {
                    display: none;
                }
            }
            .btn:hover {
                width:68px;
                height:24px;
                line-height:22px;
                text-align: center;
                border:1px solid #aaa;
                border-radius: 2px;
                color:#fff;
                font-size:14px;
                background:#8590a6;
                .btn1 {
                    display: none;
                }
                .btn2 {
                    display: inline;
                }
            }
            .username {
                margin-left: 60px;
            }
            .author-position {
                margin-left: 60px;
                color: #969696;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .bottom-line {
                height: 1px;
                background: #f0f3f6;
                margin: 15px 0 0 60px;
            }
        }
        .item:last-child .bottom-line {
            background: transparent;
        }
    }     
}
</style>